<template>
  <div class="vcv-invitation-header">
    <div class="vcv-invitation-header__title">
      <input
        v-model="header"
        v-validate="'required'"
        name="header"
        type="text"
        :placeholder="$tr('vacancy.preferences.invitation.letterTheme')"
        :class="{ error: errors.has('newUser') }"
      />
    </div>
    <div class="vcv-invitation-header__img-wrapper">
      <img v-if="companyLogo" :src="companyLogo" class="vcv-invitation-header__img" />
      <div v-else class="vcv-invitation-header__noimg">Logo</div>
      <div v-if="is_japan_locale" class="vcv-invitation-header__text">
        <router-link to="/settings/company">{{ $tr('logo-warning-with-link-name') }}</router-link>
        {{ $tr('logo-warning-with-link') }}
      </div>
      <div v-else class="vcv-invitation-header__text">
        {{ $tr('logo-warning-with-link') }}
        <router-link to="/settings/company">{{ $tr('logo-warning-with-link-name') }}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'VcvInvitationHeader',

  props: {
    invitation: {
      type: Object,
      default: () => {}
    },

    company: {
      type: Object,
      default: () => {}
    },

    vacancyName: {
      type: String,
      default: ''
    },

    activeTab: {
      type: String,
      default: ''
    }
  },

  computed: {
    ...mapGetters({
      is_japan_locale: 'locale/is_japan_locale'
    }),

    companyLogo() {
      if (this.company && this.company.logo) {
        return this.company.logo;
      }
      return false;
    },

    registerTemp() {
      return this.activeTab === 'register';
    },

    header: {
      get() {
        let headerType = this.registerTemp ? this.invitation.registration_header : this.invitation.header;

        return headerType
          .replace('{{vacancy_title}}', this.vacancyName)
          .replace('{{company_name}}', this.company.name || '');
      },

      set(newValue) {
        if (this.registerTemp) {
          this.$store.commit('vacancy/invitation/update', { registration_header: newValue });
        } else {
          this.$store.commit('vacancy/invitation/update', { header: newValue });
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.vcv-invitation-header {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 20px;

  &__title {
    display: flex;
    align-items: center;
    width: 100%;
    margin-bottom: 20px;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 22px;
    color: #233346;

    label {
      white-space: nowrap;
    }

    input {
      width: 100%;
    }
  }

  &__img-wrapper {
    position: relative;
    width: 160px;
    height: 160px;
    overflow: hidden;
  }

  &__img {
    display: inline-block;
    min-width: 100%;
    min-height: 100%;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &__noimg {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 160px;
    height: 160px;
    background-color: #fff;
    color: gray;
    opacity: 0.8;
  }

  &__text {
    padding: 8px;
    content: '';
    position: absolute;
    bottom: -60%;
    left: 0;
    width: 100%;
    height: 60%;
    background-color: rgba(0, 0, 0, 0.7);
    color: #fff;
    font-size: 14px;
    line-height: 1.2;
    text-align: center;
    opacity: 0;
    transition: all 0.3s;
  }

  &__img-wrapper:hover .vcv-invitation-header__text {
    opacity: 1;
    bottom: 0;
  }
}
</style>
